export const languages = [
  {
    language: "EN (US)",
    icon: "/image/flags/us.png",
    label: "EN (US)",
    store: "en",
  },
  {
    language: "DE",
    icon: "/image/flags/de.png",
    label: "DE",
    store: "de",
  },
  {
    language: "KO",
    icon: "/image/flags/ko.png",
    label: "KO",
    store: "ko",
  },
  {
    language: "HI",
    icon: "/image/flags/in.png",
    label: "HI",
    store: "hi",
  },
  {
    language: "ES",
    icon: "/image/flags/es.png",
    label: "ES",
    store: "es",
  },
  {
    language: "FR",
    icon: "/image/flags/fr.png",
    label: "FR",
    store: "fr",
  },
];
